import * as React from 'react';



export default class SortbyOld extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="#000" d="M6.728 12.061V1.5L3.5 4.73"/>
                <path stroke="#43ADF1" d="M9.5 3.5v10.562l3.228-3.228"/>
            </g>
        </svg>
    )
  }
}








